<template>
  <b-form-group
    label="Konu"
    label-for="title"
  >
    <v-select
      v-model="filterData.id_interview_subjects"
      :options="subjects"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'InterviewSubject',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    filterData() {
      return this.$store.getters['interviews/filterData']
    },
    subjects() {
      return this.$store.getters['interviewSubjects/dataList']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('interviewSubjects/getDataList', {
        select: [
          'interview_subjects.id AS id',
          'interview_subjects.title AS title',
        ],
      })
    },
  },
}
</script>
